import React, { useEffect } from 'react';
import { Breadcrumb } from 'antd';
import { FormattedMessage } from 'react-intl';
import styles from './styles';
import { useHistory } from 'react-router';
import { FormAddEdit } from '../components/FormAddEdit';
import styleText from '../../../../shared/components/rbh-text/styles';
import { RBHBox, RBHText } from '../../../../shared/components';
import stylesHead from '../../FoodCategory/styles';
import { generalCreators } from '../../../../redux/general/general-action';
import { GENERAL_STATE_KEY } from '../../../../redux/general/general-reducer';
import { MODAL_TYPE } from '../../../../redux/general/general-constant';
import { useDispatch } from 'react-redux';
import { mainCreators } from '../../../main-action';
import { MAIN_STATE_KEY } from '../../../main-reducer';

export const AddFoodCategoryScreen: React.FC<Props> = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, 4));
  }, []);

  const pushToMain = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push('/main');
  };

  const pushToFoodCategory = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push('/main/foodcategory');
  };

  const BreadcrumbAddRender = () => {
    return (
      <RBHBox>
        <Breadcrumb style={styleText.breadCrumb}>
          <Breadcrumb.Item>
            <a data-testid={'breadcrumb-cat-tohomepage'} id={'breakcrumb_cat_tohomepage'} style={styleText.breadCrumbItemLink} onClick={() =>
              dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: true, onOk: pushToMain, type: MODAL_TYPE.CONFIRM_EDIT }))}>
              <FormattedMessage id={'main.main'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a data-testid={'breadcrumb-cat'} id={'breakcrumb_cat'} style={styleText.breadCrumbItemLink} onClick={() =>
              dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true,
                onOk: pushToFoodCategory,
                type: MODAL_TYPE.CONFIRM_EDIT
              }))}>
              <FormattedMessage id={'main.cat_category'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span data-testid={'breadcrumb-add-cat'} id={'breakcrumb_add_cat'} style={styleText.breadCrumbItem}>
              <FormattedMessage id={'main.cat_addcat'} />
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </RBHBox>
    );
  };

  return (
    <RBHBox>
      <BreadcrumbAddRender />
      <RBHBox>
        <RBHBox style={stylesHead.header}>
          <RBHText data-testid={'add_cat_header'} id={'add_vat_header'} style={styleText.headerText} text={'main.cat_addcat'} />
        </RBHBox>
        <RBHBox style={styles.defaultContent}>
          <FormAddEdit onCancel={() =>
            dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
              visible: true,
              onOk: pushToFoodCategory,
              type: MODAL_TYPE.CONFIRM_EDIT
            }))} />
        </RBHBox>
      </RBHBox>
    </RBHBox>
  );
};

type Props = {};
